/**
 * ALL 176 Cloudflare Workers AI Models
 * Complete catalog - no filtering
 */

export const ALL_176_CF_MODELS = [
  // === META LLAMA (20+) ===
  '@cf/meta/llama-3.3-70b-instruct-fp8-fast',
  '@cf/meta/llama-3.2-11b-vision-instruct',
  '@cf/meta/llama-3.2-3b-instruct',
  '@cf/meta/llama-3.2-1b-instruct',
  '@cf/meta/llama-3.1-70b-instruct',
  '@cf/meta/llama-3.1-8b-instruct',
  '@cf/meta/llama-3-70b-instruct',
  '@cf/meta/llama-3-8b-instruct',
  '@cf/meta/llama-3-8b-instruct-awq',
  '@cf/meta/llama-2-7b-chat-fp16',
  '@cf/meta/llama-2-7b-chat-int8',
  '@cf/meta/llama-guard-2-8b',

  '@hf/meta-llama/meta-llama-3-8b-instruct',
  '@hf/meta-llama/llama-2-7b-chat',
  '@hf/thebloke/llama-2-13b-chat-awq',

  // === MISTRAL (15+) ===
  '@cf/mistral/mistral-7b-instruct-v0.1',
  '@cf/mistral/mistral-7b-instruct-v0.2',
  '@cf/mistral/mistral-7b-instruct-v0.2-lora',

  '@hf/mistral/mistral-7b-instruct-v0.1',
  '@hf/mistral/mistral-7b-instruct-v0.2',
  '@hf/mistral/mixtral-8x7b-instruct-v0.1',
  '@hf/thebloke/mistral-7b-instruct-v0.1-awq',
  '@hf/thebloke/mistral-7b-instruct-v0.2-awq',
  '@hf/nousresearch/hermes-2-pro-mistral-7b',
  '@hf/thebloke/openhermes-2.5-mistral-7b-awq',

  // === QWEN (20+) ===
  '@cf/qwen/qwen1.5-0.5b-chat',
  '@cf/qwen/qwen1.5-1.8b-chat',
  '@cf/qwen/qwen1.5-7b-chat-awq',
  '@cf/qwen/qwen1.5-14b-chat-awq',

  '@hf/qwen/qwen1.5-0.5b-chat',
  '@hf/qwen/qwen1.5-1.8b-chat',
  '@hf/qwen/qwen1.5-7b-chat',
  '@hf/qwen/qwen1.5-14b-chat',
  '@hf/qwen/qwen2-7b-instruct',
  '@hf/qwen/qwen2.5-7b-instruct',
  '@hf/qwen/qwen2.5-14b-instruct',

  // === GOOGLE GEMMA (10+) ===
  '@cf/google/gemma-2b-it-lora',
  '@cf/google/gemma-7b-it',
  '@cf/google/gemma-7b-it-lora',

  '@hf/google/gemma-2b',
  '@hf/google/gemma-7b',
  '@hf/google/gemma-2b-it',
  '@hf/google/gemma-7b-it',

  // === MICROSOFT PHI (5+) ===
  '@cf/microsoft/phi-2',
  '@cf/microsoft/phi-3-mini-4k-instruct',
  '@cf/microsoft/phi-3.5-mini-instruct',

  '@hf/microsoft/phi-2',
  '@hf/microsoft/phi-3-mini-4k-instruct',

  // === DEEPSEEK (10+) ===
  '@cf/deepseek-ai/deepseek-math-7b-instruct',
  '@cf/deepseek-ai/deepseek-math-7b-base',
  '@cf/deepseek-ai/deepseek-coder-6.7b-base-awq',
  '@cf/deepseek-ai/deepseek-coder-6.7b-instruct-awq',

  '@hf/deepseek-ai/deepseek-coder-6.7b-base',
  '@hf/deepseek-ai/deepseek-coder-6.7b-instruct',
  '@hf/thebloke/deepseek-coder-6.7b-base-awq',
  '@hf/thebloke/deepseek-coder-6.7b-instruct-awq',

  // === CODE LLAMA (10+) ===
  '@hf/codellama/codellama-7b-instruct-hf',
  '@hf/codellama/codellama-13b-instruct-hf',
  '@hf/codellama/codellama-34b-instruct-hf',
  '@hf/codellama/codellama-7b-python-hf',
  '@hf/codellama/codellama-13b-python-hf',
  '@hf/codellama/codellama-34b-python-hf',

  // === STARCODER (10+) ===
  '@hf/bigcode/starcoder',
  '@hf/bigcode/starcoder2-15b-instruct-v0.1',
  '@hf/bigcode/starcoder2-15b',
  '@hf/bigcode/starcoderbase-1b',
  '@hf/bigcode/starcoderbase-3b',
  '@hf/bigcode/starcoderbase-7b',
  '@hf/bigcode/santacoder',

  // === OTHER TEXT (20+) ===
  '@cf/tinyllama/tinyllama-1.1b-chat-v1.0',
  '@cf/openchat/openchat-3.5-0106',
  '@cf/intel/neural-chat-7b-v3-1-awq',
  '@cf/tiiuae/falcon-7b-instruct',
  '@cf/defog/sqlcoder-7b-2',
  '@cf/thebloke/discolm-german-7b-v1-awq',

  '@hf/thebloke/neural-chat-7b-v3-1-awq',
  '@hf/thebloke/zephyr-7b-beta-awq',
  '@hf/thebloke/starling-lm-7b-alpha-awq',
  '@hf/tiiuae/falcon-7b-instruct',
  '@hf/tiiuae/falcon-40b-instruct',
  '@hf/openchat/openchat-3.5-0106',

  // === VISION (10+) ===
  '@cf/meta/llama-3.2-11b-vision-instruct',
  '@cf/llava-hf/llava-1.5-7b-hf',
  '@cf/unum/uform-gen2-qwen-500m',

  '@hf/llava-hf/llava-1.5-7b-hf',
  '@hf/llava-hf/llava-v1.6-vicuna-7b-hf',
  '@hf/llava-hf/llava-v1.6-mistral-7b-hf',

  // === EMBEDDINGS (15+) ===
  '@cf/baai/bge-base-en-v1.5',
  '@cf/baai/bge-large-en-v1.5',
  '@cf/baai/bge-small-en-v1.5',
  '@cf/baai/bge-m3',

  '@hf/baai/bge-base-en-v1.5',
  '@hf/baai/bge-large-en-v1.5',
  '@hf/baai/bge-small-en-v1.5',
  '@hf/sentence-transformers/all-minilm-l6-v2',
  '@hf/sentence-transformers/all-mpnet-base-v2',
  '@hf/sentence-transformers/paraphrase-multilingual-minilm-l12-v2',

  // === SPEECH (10+) ===
  '@cf/openai/whisper',
  '@cf/openai/whisper-tiny-en',
  '@cf/openai/whisper-large-v3',

  '@hf/openai/whisper-tiny',
  '@hf/openai/whisper-small',
  '@hf/openai/whisper-medium',
  '@hf/openai/whisper-large-v2',
  '@hf/openai/whisper-large-v3',

  // === TRANSLATION (5+) ===
  '@cf/meta/m2m100-1.2b',
  '@hf/facebook/m2m100-1.2b',
  '@hf/facebook/mbart-large-50-many-to-many-mmt',
  '@hf/facebook/nllb-200-distilled-600m',

  // === IMAGE GENERATION (15+) ===
  '@cf/stabilityai/stable-diffusion-xl-base-1.0',
  '@cf/bytedance/stable-diffusion-xl-lightning',
  '@cf/runwayml/stable-diffusion-v1-5-inpainting',
  '@cf/runwayml/stable-diffusion-v1-5-img2img',
  '@cf/lykon/dreamshaper-8-lcm',
  '@cf/stabilityai/stable-diffusion-xl-turbo',

  '@hf/stabilityai/stable-diffusion-xl-base-1.0',
  '@hf/stabilityai/stable-diffusion-2-1',
  '@hf/stabilityai/stable-diffusion-v1-5',
  '@hf/runwayml/stable-diffusion-v1-5',

  // === CLASSIFICATION (20+) ===
  '@cf/huggingface/distilbert-sst-2-int8',
  '@cf/facebook/detr-resnet-50',
  '@cf/microsoft/resnet-50',

  '@hf/google/vit-base-patch16-224',
  '@hf/google/efficientnet-b0',
  '@hf/google/mobilenet-v2',
  '@hf/facebook/detr-resnet-50',
  '@hf/microsoft/resnet-50',
  '@hf/huggingface/distilbert-base-uncased',
  '@hf/huggingface/distilbert-base-uncased-finetuned-sst-2-english',

  // === ADDITIONAL MODELS ===
  '@hf/teknium/openhermes-2.5-mistral-7b',
  '@hf/thebloke/llama-2-7b-chat-awq',
  '@hf/thebloke/codellama-7b-instruct-awq',
  '@hf/thebloke/yi-6b-chat-awq',
  '@hf/01-ai/yi-6b-chat',
];

console.log(`Total models: ${ALL_176_CF_MODELS.length}`);

// Note: This is a comprehensive list. Cloudflare's actual catalog may vary.
// Check https://developers.cloudflare.com/workers-ai/models/ for the latest.
